// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addWorkingTemplate {
  background-color: #f3f4f6;
  padding-bottom: 120px;
}
.addWorkingTemplate .titleBar {
  width: 90%;
  margin: auto;
  padding-top: 60px;
}
.addWorkingTemplate .titleBar .header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.addWorkingTemplate .titleBar .subHeader {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.addWorkingTemplate .container {
  margin: auto;
  width: 90%;
  background-color: white;
  margin-top: 32px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-bottom: 20px;
}
.addWorkingTemplate .container .leftContainer {
  width: 70%;
  height: 100%;
  display: inline-block;
  padding-left: 32px;
  padding-right: 32px;
  border-right: 1px solid #F2F2F2;
}
.addWorkingTemplate .container .leftContainer .header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
  position: relative;
  top: 32px;
  padding-bottom: 32px;
}
.addWorkingTemplate .container .leftContainer .areaHead {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.addWorkingTemplate .container .leftContainer .checkboxRow {
  margin-top: 18px;
  margin-bottom: 40px;
}
.addWorkingTemplate .container .leftContainer .checkboxRow .checkBoxWrapper {
  display: inline-block;
  margin-right: 30px;
}
.addWorkingTemplate .container .rightContainer {
  width: 30%;
  height: 300px;
  position: relative;
  bottom: 466px;
  display: inline-block;
  padding-left: 32px;
  padding-right: 32px;
}
.addWorkingTemplate .container .rightContainer .title {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.addWorkingTemplate .container .rightContainer .description {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}`, "",{"version":3,"sources":["webpack://./src/screens/addWorkingTemplate/addWorkingTemplate.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,qBAAA;AACJ;AACI;EACI,UAAA;EACA,YAAA;EACA,iBAAA;AACR;AACQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACZ;AACQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACZ;AAGI;EACI,YAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,4CAAA;EACA,kBAAA;EACA,mBAAA;AADR;AAEQ;EACI,UAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;AAAZ;AACY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,oBAAA;AAChB;AAEY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAhB;AAEY;EACI,gBAAA;EACA,mBAAA;AAAhB;AACgB;EACI,qBAAA;EACA,kBAAA;AACpB;AAIQ;EACI,UAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAFZ;AAIY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFhB;AAKY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHhB","sourcesContent":[".addWorkingTemplate {\n    background-color: #f3f4f6;\n    padding-bottom: 120px;\n \n    .titleBar {\n        width: 90%;\n        margin: auto;\n        padding-top: 60px;\n\n        .header {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n        .subHeader {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n        }\n    }\n\n    .container {\n        margin: auto;\n        width: 90%;\n        background-color: white; \n        margin-top: 32px;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px; \n        margin-bottom: 20px;\n        .leftContainer {\n            width: 70%;\n            height: 100%;\n            display: inline-block;\n            padding-left: 32px;\n            padding-right: 32px; \n            border-right: 1px solid #F2F2F2;\n            .header {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 20px;\n                line-height: 30px;\n                color: #333333;\n                position: relative;\n                top: 32px;\n                padding-bottom: 32px;\n            }\n\n            .areaHead{\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px; \n                color: #505054;\n            }\n            .checkboxRow {\n                margin-top: 18px;\n                margin-bottom: 40px;\n                .checkBoxWrapper {\n                    display: inline-block;\n                    margin-right: 30px;\n                }\n            }\n        }\n\n        .rightContainer {\n            width: 30%;\n            height: 300px;\n            position: relative;\n            bottom: 466px;\n            display: inline-block;\n            padding-left: 32px;\n            padding-right: 32px;  \n\n            .title {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n            }\n\n            .description {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                color: #999999;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
